import { GridColumnType } from "../../../../components/molGrid/libs/data/gridColumnType";

export const reportTemplateGridConfig = {
  isRowSelectable: true,
  allowEdit: false,
  hasChildGridTable: false,
  columns: [
    {
      name: "Name",
      fieldName: "reportTemplateName",
      colStyle: {
        textAlign: "left",
        width: "20%",
      },
      allowShort: true,
    },
    {
      name: "Report Type",
      fieldName: "reportType",
      colStyle: {
        textAlign: "left",
        width: "20%",
      },
      allowShort: true,
    },
    {
      name: "Description",
      fieldName: "reportTemplateDescription",
      colStyle: {
        textAlign: "left",
        width: "45%",
      },
      allowShort: false,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.TOGGLE,
      colSettings: {
        isChecked: true,
        isDisabled: false,
      },
      colStyle: {
        textAlign: "center",
        width: "8%",
      },
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
      colStyle: {
        width: "7%",
      },
      customAction: [
        {
          name: "DOWNLOAD_Report",
          iconClass: "hugeicons:csv-01",
        },
       
      ],
    },
  ],
};
